module.exports = __webpack_public_path__ + "img/carsat.9a141e49.png";